import React, { useEffect, useState } from "react";
import useHttp from "../../../../hooks/use-http";

import Pagination from "../../../../components/Pagination";
import { Modal as AntModal } from "antd";
import moment from "moment";
import Modal from "react-modal";
import { toast } from "react-toastify";

const SqcListview = (props) => {
  const [loginUserId, setLoginUserId] = useState(localStorage.getItem("id"));
  const [canAdd, setCanAdd] = useState("none");
  const [canEdit, setCanEdit] = useState("none");
  const [canDelete, setCanDelete] = useState("none");
  const [canPdf, setCanPdf] = useState("none");
  const [canView, setCanView] = useState("none");
  const [serviceId, setServiceId] = useState("none");
  

  useEffect(() => {
    var urlpathname = window.location.pathname;
    var roleAllocation = JSON.parse(localStorage.getItem("RoleAllocation"));

    if (roleAllocation && roleAllocation.length > 0) {
      //console.log("roleAllocation", roleAllocation);

      var roleAllocationFilterList = roleAllocation.filter(
        (item) => item.serviceUrl == urlpathname
      );
      //console.log("roleAllocationFilterList", roleAllocationFilterList);
      if (roleAllocationFilterList && roleAllocationFilterList.length > 0) {
        var itemselected = roleAllocationFilterList[0];

        console.log(itemselected);

        setServiceId(itemselected.serviceId);
        if (itemselected.canAddStatus == true) {
          setCanAdd("block");
        }

        if (itemselected.canEditStatus == true) {
          setCanEdit("block");
        }

        if (itemselected.canDeleteStatus == true) {
          setCanDelete("block");
        }
        if (itemselected.canViewStatus == true) {
          setCanView("block");
        }

        if (itemselected.canPdfStatus == true) {
          setCanPdf("block");
        }
        //console.log("canAdd", canAdd);
      }
    }
  }, []);
  const customModalStyles = {
    overlay: {
      backgroundColor: "rgba(0, 0, 0, 0.5)",
      zIndex: 1000,
    },
    content: {
      top: "50%",
      left: "50%",
      transform: "translate(-50%, -50%)",
      maxWidth: "80%",
      width: "700px", // Adjust the width as needed
      height: "80%",
      minHeight: "500px",
      overflow: "auto",
      border: "5px solid #96dc00",
    },
  };

  const { addForm, update, sId } = props;
  const [data, setData] = useState([]);
  const [sqcData, setSqcData] = useState([]);

  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedData, setSelectedData] = useState(null);

  const [paramterDetail, setParamterDetail] = useState();

  const openModal = (data) => {
    //console.log(data);

    const seedQCId = data && data.seedQCId;

    getSqc(
      {
        url: `/api/seedQualityCheck/?seedQCId=${seedQCId}`,
      },
      (res) => {
        //console.log(res);
        setParamterDetail(res && res.paramterDetail);
      }
    );

    setSelectedData(data);
    setIsModalOpen(true);
  };

  const closeModal = () => {
    setIsModalOpen(false);
  };

  const { sendRequest: getSqc } = useHttp();

  const getData = () => {
    getSqc(
      {
        url: `/api/seedQualityCheck/?orgId=${localStorage.getItem(
          "orgId"
        )}&warehouseId=${localStorage.getItem("warehouseId")}`,
      },
      (res) => {
        // //console.log(res);
        const sortedData = res.sort((a, b) => b.seedQCId - a.seedQCId);

        setData(sortedData);
        setSqcData(res);
      }
    );
  };

  useEffect(() => {
    getData();
  }, []);

  const [itemsPerPage] = useState(10);
  const [currentPage, setCurrentPage] = useState(1);
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = data && data.slice(indexOfFirstItem, indexOfLastItem);

  const paginate = (pageNumber) => {
    setCurrentPage(pageNumber);
  };

  const handleSearch = (e) => {
      var filetrtext = e.target.value.trim().toLowerCase();

    var filterdata =
      sqcData &&
      sqcData.filter(
        (item) =>
          item.seedQCNo.includes(filetrtext) ||
          item.inputProductName.includes(filetrtext)
      );

   setData(filterdata); 
                                
setCurrentPage(1);
  };

 

  return (
    <>
      <div className="content-wrapper">
        <div className="row mx-2">
          <div className="col-6">
            <label className="card-title mx-3 my-3">Seed Quality Check</label>
          </div>

          <div className="col-6 text-right">
            {canAdd === "block" && (
              <button
                type="button"
                className="btn  btn-primary mx-3 my-3"
                onClick={() => {
                  addForm(true);
                  sId(serviceId);
                  props.update(false);
                }}
              >
                Add Seed Quality
              </button>
            )}
          </div>
        </div>

        <section className="content">
          <div className="container-fluid">
            <div className="row">
              <div className="col-md-12">
                <div className="card">
                  <div className="card-body" style={{ padding: "0.4rem" }}>
                    <div className="row">
                      <div className="col-4"> </div>
                      <div className="col-4"> </div>

                      <div className="col-4">
                        <input
                          type="text"
                          name="q"
                          className="form-control"
                          onKeyUp={(e) => {
                            handleSearch(e);
                          }}
                          placeholder="Search..."
                        />
                      </div>
                    </div>
                    <br />
                    <table className="table table-bordered text-center">
                      <thead>
                        <tr>
                          <th>Seed Qc Date</th>
                          <th>InspectionTime</th>
                          <th>Doc No</th>
                          <th>Lot No</th>
                          <th>Inspected By</th>
                          <th>Product Name</th>
                          <th>Available Quantity</th>

                          <th>Seed Product Name</th>
                        
                          {canDelete === "block" && <th>Delete</th>}
                          {canView === "block" && <th>View</th>}
                        </tr>
                      </thead>

                      <tbody>
                        {currentItems &&
                          currentItems.map((itm, i) => {
                            return (
                              <tr key={i}>
                                <td>{itm.seedQCDate}</td>
                                <td>
                                  {moment(itm.timeStamp, "HH:mm:ss").format(
                                    "hh:mm A"
                                  )}
                                </td>
                                <td>{itm.seedQCNo}</td>
                                <td>{itm.lotNo}</td>
                                <td>{itm.employeeName}</td>

                                <td>{itm.inputProductName}</td>
                                <td>
                                  {itm.TotalinputWeight +
                                    " " +
                                    itm.unitAbbreviation}
                                </td>

                                <td>{itm.seedProductName}</td>
                              
                                {canDelete === "block" && (
                                  <td>
                                    <button
                                      type="button"
                                      //onClick={(e) => handleDelete(e, itm)}
                                      className="btn"
                                    >
                                      <i className="fas fa-trash"></i>
                                    </button>
                                  </td>
                                )}
                                {canView === "block" && (
                                  <td>
                                    <button
                                      className="btn"
                                      onClick={() => openModal(itm)}
                                    >
                                      <i className="fas fa-eye"></i>
                                    </button>
                                  </td>
                                )}
                              </tr>
                            );
                          })}
                      </tbody>
                    </table>
                  </div>
                  {/* /.card-body */}
                  <div className="card-footer clearfix">
                    <Pagination
                      totalItems={data.length}
                      itemsPerPage={itemsPerPage}
                      onPageChange={paginate}
                      currentPage={currentPage}
                      setCurrentPage={setCurrentPage}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>

      <Modal isOpen={isModalOpen} style={customModalStyles}>
        {selectedData && (
          <div className="">
            <div className="">
              <h3 className="card-title">Seed Quality Check Details</h3>
              <div className="card-tools text-right">
                <button
                  type="button"
                  className="btn btn-tool"
                  data-card-widget="remove"
                  onClick={() => setIsModalOpen(false)}
                >
                  <i className="fas fa-times" />
                </button>
                <hr />
              </div>
            </div>
            <div className="row">
              <p className="col-md-6">Date: {selectedData.seedQCDate}</p>
              <p className="col-md-6">
                Time:
                {moment(selectedData.timeStamp, "HH:mm:ss").format("hh:mm A")}
              </p>
            </div>
            <div className="row">
              <p className="col-md-6">Doc No: {selectedData.seedQCNo}</p>
              <p className="col-md-6">
                Inspected By: {selectedData.employeeName}
              </p>
            </div>
            <div className="row">
              <p className="col-md-6">Lot No: {selectedData.lotNo}</p>
              <p className="col-md-6">
                Lot Quantity: {selectedData.TotalinputWeight}
              </p>
            </div>
            <div className="row">
              <p className="col-md-6">Unit: {selectedData.unitAbbreviation}</p>
              <p className="col-md-6">
                Temperature(°C): {selectedData.temperature}
              </p>
            </div>
            <div className="row">
              <p className="col-md-6">
                Product Name: {selectedData.inputProductName}
              </p>

              <p className="col-md-6">Crop Name: {selectedData.cropName}</p>
            </div>
            <div className="row">
              <p className="col-md-6">
                Variety Name: {selectedData.varietyName}
              </p>
              <p className="col-md-6">
                Seed Product Name: {selectedData.seedProductName}
              </p>
            </div>
            <div className="row">
              <p className="col-md-6">Result: {selectedData.result}</p>
            </div>

            <div className="row">
              <h5 className="col-md-6 card-title">Check List Details: </h5>
            </div>
            <br />
            <div className="row">
              <p className="col-md-6">
                Contamination:{" "}
                {selectedData.checkList &&
                  selectedData.checkList[0].contamination}
              </p>
              <p className="col-md-6">
                Uniform Size:{" "}
                {selectedData.checkList &&
                  selectedData.checkList[0].uniformSize}
              </p>
            </div>
            <div className="row">
              <p className="col-md-6">
                Fungicide Detection :{" "}
                {selectedData.checkList &&
                  selectedData.checkList[0].fungicideDetection}
              </p>
              <p className="col-md-6">
                Free from stones,debris and dust :{" "}
                {selectedData.checkList &&
                  selectedData.checkList[0].FreefromSDD}
              </p>
            </div>
            <div className="row">
              <p className="col-md-6">
                Free from leafs,twigs,stems,flowers :{" "}
                {selectedData.checkList &&
                  selectedData.checkList[0].FreefromLTSF}
              </p>
            </div>
            <h5 className="card-title">Observation Paramter Details</h5>
            <table className="table table-sm table-bordered">
              <thead>
                <tr>
                  <th>Sr No</th>
                  <th>Paramter Name</th>
                  <th>Stdndard Observation</th>
                  <th>Observation</th>
                  <th>Remark</th>
                </tr>
              </thead>
              <tbody>
                {paramterDetail &&
                  paramterDetail.map((itm, i) => {
                    return (
                      <tr key={i}>
                        <td>{i + 1}</td>
                        <td>{itm.parameterName}</td>
                        <td>{itm.standardObservation}</td>
                        <td>{itm.observation}</td>
                        <td>{itm.remark}</td>
                      </tr>
                    );
                  })}
              </tbody>
            </table>
          </div>
        )}
      </Modal>

    
    </>
  );
};

export default SqcListview;
